import { NgModule } from '@angular/core';

import { PropertyPageRoutingModule } from './property-routing.module';

@NgModule({
  declarations: [],
  imports: [PropertyPageRoutingModule],
  providers: []
})
export class PropertyPageModule {}
